/* eslint-disable */
import React, {Component} from 'react'

import { connect } from 'react-redux'
import { switchConversation, switchSendNumber, updateConversation, updateConversations } from '../../actions/conversations'
import { switchView } from '../../actions/view'

import api from '../../util/api_v2'

import ConversationSelectorItem from './ConversationSelectorItem'

import ScrollerWrapper from 'scroller-wrapper'

const mapStateToProps = state => {
	return {
		currentConversation:	state.conversations.find(c => c.selected),
		conversations:			state.conversations,
		smallView:				state.smallView,
		currentView:			state.currentView
	}
}
const mapDispatchToProps = dispatch => {
	return {
		switchConversation:		conv	=> dispatch(switchConversation(conv)),
		updateConversation:		conv	=> dispatch(updateConversation(conv)),
		switchView:				view	=> dispatch(switchView(view)),
		switchSendNumber:		num		=> dispatch(switchSendNumber(num)),
		updateConversations:	convs	=> dispatch(updateConversations(convs))
	}
}

class ConversationSelector extends Component {

	onConversationClick = conversation => {

		// Mark as read
		if (conversation.unread_messages > 0) {
			let prevNumUnreadMessages		= conversation.unread_messages
			conversation.unread_messages	= 0
			conversation.pauseMarkingRead	= false
			conversation.scrollToMessage	= conversation.last_unread_message_id
			conversation.messages && conversation.messages.forEach(m => {
				if (!m.read_at) {
					m.read_at = parseInt((new Date()).getTime()/1000)
				}
			})
			conversation.markedUnreadAt = null
			this.props.updateConversation(conversation)
			setTimeout(() => {
				if (conversation.markedUnreadAt) return
				conversation = this.props.conversations.find(c => c.id === conversation.id)
				conversation.last_unread_message_id	= null
				if (this.props.currentConversation && conversation.id === this.props.currentConversation.id) conversation.selected = true
				this.props.updateConversation(conversation)
			}, 2000)
			this.props.changeMessageReadStatus('read', prevNumUnreadMessages)
			api.markConversationRead(conversation.id, parseInt((new Date()).getTime()/1000)).then(() => this.props.updateUnreadCounts())
		}

		this.props.updateRouterHistory(`c${conversation.id}`)
		this.props.switchConversation(conversation)
		this.props.switchView('content')

		if (conversation.from.length) {
			this.props.switchSendNumber(conversation.from[0].number)
		} else {
			this.props.switchSendNumber(null)
		}

		// let typeMessageField = document.getElementById('type-message-field')
		// if (typeMessageField) typeMessageField.focus()
	}
	isConversationActive = conversation => {
		if (this.props.smallView || this.props.currentView === 'new_conversation') return false
		if (this.props.currentConversation) return conversation.id === this.props.currentConversation.id
		return false
	}

	render() {
		let { conversations } = this.props		
		let scrollItemIndex = conversations.findIndex(c => c.scrollToConversation === true)
		if (scrollItemIndex === -1) scrollItemIndex = null
		return (
			<div style={{height: '100%'}}>
				<ScrollerWrapper
					reverseScroll	= {false}
					loadMore		= {this.props.loadMore}
					hasMore			= {this.props.hasMore}
					items			= {this.props.conversations}
					scrollItemIndex	= {scrollItemIndex}
					updateItems		= {conversations => this.props.updateConversations(conversations)}
					smallView		= {this.props.smallView}
				>
					{this.props.conversations.map(c =>
						<ConversationSelectorItem
							conversation		= {c}
							key					= {c.id}
							onClick				= {() => this.onConversationClick(c)}
							active				= {this.isConversationActive(c)}
							extraContacts		= {this.props.extraContacts}
							placeholderHeight	= {c.placeholderHeight}
							dontShow			= {c.dontShow}
						/>
					)}
				</ScrollerWrapper>
			</div>
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationSelector)